import {
    sendEmailVerification,
    signInWithEmailAndPassword,
    signOut,
} from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import getLoginUser from "modules/getLoginUser";
import { userConverter } from "types/firestoreTypes";
import { auth, db } from "firebaseConfig";
import { useState } from "react";
import DefaultTemplate from "components/templates/DefaultTemplate";

const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    /**
     * ログイン
     * 認証済みでないならメールを送信する
     * @param mail メールアドレス
     * @param pass パスワード
     * @returns ログインに成功し、認証済みならtrue、そうでないならfalseがresolveされるPromise
     */
    const login = (mail: string, pass: string): Promise<boolean> => {
        return new Promise((resolve, reject) => {
            signInWithEmailAndPassword(auth, mail, pass)
                .then((u) => {
                    if (u.user.emailVerified) {
                        resolve(true);
                    } else {
                        sendEmailVerification(u.user, {
                            url: "https://tic-s3.web.app/login",
                        });
                        resolve(false);
                    }
                })
                .catch((e) => {
                    reject(e.code);
                });
        });
    };

    return (
        <DefaultTemplate className="login">
            <form
                name="login_form"
                id="loginForm"
                style={{ height: "100%" }}
                onSubmit={(e) => {
                    e.preventDefault();
                    login(email, password)
                        .then(async (res) => {
                            if (res) {
                                const user = (await getLoginUser())!;
                                const document = (
                                    await getDoc(
                                        doc(
                                            db,
                                            `users/${user.uid}`
                                        ).withConverter(userConverter)
                                    )
                                ).data();
                                if (!document) {
                                    throw new Error(
                                        "user document is not found"
                                    );
                                }
                                if (document.type === "user") {
                                    window.location.href = "/";
                                } else if (document.type === "moll_admin") {
                                    window.location.href = "/admin/";
                                } else {
                                    window.location.href = "/admin/";
                                }
                            } else {
                                signOut(auth);
                                alert(
                                    `
                                メールアドレス認証が済んでいません\n
                                ${email}に送信されたメールのURLをクリックして認証を完了してください
                                `
                                );
                            }
                        })
                        .catch((e) => {
                            alert(e);
                        });
                }}
            >
                <div className="login_form_top">
                    <h1>LOGIN</h1>
                    <p>
                        UserID、Passwordをご入力の上、「LOGIN」ボタンをクリックしてください。
                    </p>
                </div>
                <div className="login_form_btm">
                    <input
                        type="email"
                        name="email"
                        placeholder="Mail Address"
                        id="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <input
                        type="password"
                        name="password"
                        placeholder="Password"
                        id="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <input type="submit" name="botton" value="LOGIN" />
                </div>
            </form>
        </DefaultTemplate>
    );
};

export default Login;
